import { useRouter } from 'vue-router'
import api from '@/api'
import { onMounted, toRef, reactive } from 'vue'

export default function useHomeLogic() {
    const router = useRouter()
    const data = reactive({
        linksOfPoints: [],
        linksOfRights: [],
        linksOfHot: [],
    })

    const onRoute = (url) => {
        if (!url) {
            return
        }
        router.push(url)
    }

    const getLinksByGroupCode = async (code) => {
        const res = await api.getLinksByGroupCode(code)
        return res
    }

    const mapGroupToLinks = (group) => {
        return group.map(linkResp => {
            const { image, gotoUrl,title } = linkResp
            if (gotoUrl.indexOf(',') === -1) {
                return {
                    image,
                    loginedUrl: gotoUrl,
                    unLoginedUrl: gotoUrl,
                    title
                }
            }

            const [loginedUrl, unLoginedUrl] = gotoUrl.split(',')
            // const [unLoginedUrl, loginedUrl] = String.prototype.split.call(gotoUrl, ',')
            return {
                image,
                loginedUrl,
                unLoginedUrl,
                title
            }
        })
    }

    onMounted(() => {
        getLinksByGroupCode('group5').then(res => {
            data.linksOfPoints = mapGroupToLinks(res.data.linkResps)
        })
        getLinksByGroupCode('group6').then(res => {
            data.linksOfRights = mapGroupToLinks(res.data.linkResps)
        })
        getLinksByGroupCode('group7').then(res => {
            data.linksOfHot = mapGroupToLinks(res.data.linkResps)
        })
    })

    return {
        linksOfPoints: toRef(data, 'linksOfPoints'),
        linksOfRights: toRef(data, 'linksOfRights'),
        linksOfHot: toRef(data, 'linksOfHot'),

        onRoute,
    }
}